/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetTimeEntryTypeResponse
 */
export interface GetTimeEntryTypeResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetTimeEntryTypeResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetTimeEntryTypeResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetTimeEntryTypeResponse
     */
    description: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTimeEntryTypeResponse
     */
    useEmployeePayRate: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTimeEntryTypeResponse
     */
    useAppointmentPayRate: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetTimeEntryTypeResponse
     */
    percentage: number;
    /**
     * 
     * @type {number}
     * @memberof GetTimeEntryTypeResponse
     */
    hourlyPayRate: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetTimeEntryTypeResponse
     */
    isSystem: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTimeEntryTypeResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTimeEntryTypeResponse
     */
    roles: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof GetTimeEntryTypeResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetTimeEntryTypeResponse
     */
    updatedAt: Date | null;
}

/**
 * Check if a given object implements the GetTimeEntryTypeResponse interface.
 */
export function instanceOfGetTimeEntryTypeResponse(value: object): value is GetTimeEntryTypeResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('useEmployeePayRate' in value) || value['useEmployeePayRate'] === undefined) return false;
    if (!('useAppointmentPayRate' in value) || value['useAppointmentPayRate'] === undefined) return false;
    if (!('percentage' in value) || value['percentage'] === undefined) return false;
    if (!('hourlyPayRate' in value) || value['hourlyPayRate'] === undefined) return false;
    if (!('isSystem' in value) || value['isSystem'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GetTimeEntryTypeResponseFromJSON(json: any): GetTimeEntryTypeResponse {
    return GetTimeEntryTypeResponseFromJSONTyped(json, false);
}

export function GetTimeEntryTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTimeEntryTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
        'description': json['description'],
        'useEmployeePayRate': json['useEmployeePayRate'],
        'useAppointmentPayRate': json['useAppointmentPayRate'],
        'percentage': json['percentage'],
        'hourlyPayRate': json['hourlyPayRate'],
        'isSystem': json['isSystem'],
        'isActive': json['isActive'],
        'roles': json['roles'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}

export function GetTimeEntryTypeResponseToJSON(json: any): GetTimeEntryTypeResponse {
    return GetTimeEntryTypeResponseToJSONTyped(json, false);
}

export function GetTimeEntryTypeResponseToJSONTyped(value?: GetTimeEntryTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
        'description': value['description'],
        'useEmployeePayRate': value['useEmployeePayRate'],
        'useAppointmentPayRate': value['useAppointmentPayRate'],
        'percentage': value['percentage'],
        'hourlyPayRate': value['hourlyPayRate'],
        'isSystem': value['isSystem'],
        'isActive': value['isActive'],
        'roles': value['roles'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

